<style scoped>
    .main {
        background-color: var(--ion-background-color);
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        flex-grow: 1;
    }

    .chart-holder {
        flex-grow: 1;
        min-height: 0;
        flex-basis: 0;
        position: relative;
    }

    .chart-holder canvas {
        position: absolute;
        background-color: transparent;
    }

    .cursor-canvas {
        z-index: 1;
    }

    canvas {
        background-color: var(--ion-background-color);
        width: 100%;
        height: 100%;
    }

    .signal-label-box {
        position: absolute;
        z-index: 10;
        cursor: pointer;
    }
</style>

<div class="main">
    <div class="chart-holder">
        <canvas #chartCanvas></canvas>
        <canvas
            #cursorCanvas
            class="cursor-canvas"
            (mousedown)="onChartMousedown($event)"
            (touchstart)="onChartTouchstart($event)"
            (touchmove)="onChartTouchmove($event)"
            (touchend)="onChartTouchend($event)"
            (wheel)="onWheel($event)"
        ></canvas>
        @for (box of signalLabelBoxes; track $index) {
            <div
                class="signal-label-box"
                [style.left]="box.left"
                [style.right]="box.right"
                [style.top]="box.top"
                [style.bottom]="box.bottom"
                (click)="box.onClicked()"
            ></div>
        }
    </div>
</div>
